import Axios from 'axios'
import { getCookie, saveCookie } from '../utils/auth-utils'
import Vue from 'vue'

function toggleDefaultData() {
  let cookie = getCookie('toggleAol')
  if (cookie) {
    return cookie
  } else {
    return {
      feature: {
        toggleManage: false,
        results: false,
        maintenance: false,
        exam_urgent: false,
        spinner: false,
        notification_edit: false,
        notification_view: false,
        exam_exclusion: false,
        exam_inclusion: false,
        feedback: false,
        examListLink: false,
        billetLink: false,
        prePaid: false,
        isLimitedPost: false,
        documentsLink: false,
        priceListLink: false,
        deepwater: false,
        responsibleSignature: false,
        mergeAfterTransferred: false,
        examDocument: false,
        userExamDocument: false,
        examLISTagEvenIfEmpty: false,
        bloodCount: false,
        sortByFile: false,
        collectDate: false,
        consentForm: false,
        pendenciesManagement: false,
        recollect: false,
        collectPlace: false,
        covax: false,
        integrationAOLWs: false,
        reportGenerator: false,
        microbiologyReport: false,
        profileExam: false,
        patientManagement: false,
        fileImport: false,
        patientView: false,
        supplyManagement: false,
        genera: false,
        biometricData: false,
        webPrinting: false,
        recollectReport: false,
        pendingSamplesReport: false,
        rescheduledReport: false,
        nonSegregatedBatchList: false,
        examGuidePrice: false,
        helpCenterTutorial: false,
        rescheduleList: false,
        sampleTraceability: false,
        manualServiceOrderRegistration: false,
        interlabVoucher: false,
        serviceOrderList: false,
        tagPrint: false,
        paternity: false,
        toxicology: false,
        shoppingCenter: false,
        xmlImport: false,
        examResultsPDF: false,
        crudUser: false,
        rollbacklaudasa: false,
        generalData: false,
        printerPlugin: false,
        traceability: false,
      },
    }
  }
}

const toggleSettings = new Vue({
  data() {
    return {
      toggle: toggleDefaultData(),
    }
  },
})

const toggleService = {
  toggleSettings: toggleSettings,
  /**
   * Apply the toggle struture from database to a Json
   * @param {Array} fetchedToggles - Each element of the array has a string-based key and a enabled property
   * @param {Array} sysToggles - Original toggles, usually the same strucuture available for $toggles
   */
  applyToggle(fetchedToggles, sysToggles) {
    let updatedToggles = { feature: { ...sysToggles.feature } }

    resetToggleValues(updatedToggles.feature)

    fetchedToggles.forEach(function (toggleName) {
      let walker = updatedToggles.feature

      if (walker[toggleName] !== undefined) {
        walker[toggleName] = true
      }
    })

    saveCookie('toggleAol', updatedToggles)

    return updatedToggles
  },

  setToggles(toggleList) {
    toggle = this.applyToggle(toggleList, toggleSettings.toggle)
    return toggle
  },

  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.BASE_URL_API
    return AxiosInstance
  },

  callToggleService() {
    return this.axios().get('/authentication-api/manage/feature-toggle')
  },

  toggleManage(feature) {
    return this.axios().put('/authentication-api/manage/feature-toggle', feature)
  },
}

let resetToggleValues = function (toggleRoot) {
  for (var k in toggleRoot) {
    if (typeof toggleRoot[k] === 'object' && toggleRoot[k] !== null) {
      resetToggleValues(toggleRoot[k])
    } else {
      if (toggleRoot[k] === true) {
        toggleRoot[k] = false
      }
    }
  }
}

let toggle = toggleService.toggleSettings.toggle

export default toggleService
export { toggle }
export { toggleService }
export { toggleSettings }
export { toggleDefaultData }
